import { type AdaptiveCardsStyleOptions } from './AdaptiveCardsStyleOptions';

const ADAPTIVE_CARDS_DEFAULT_STYLE_OPTIONS: Required<AdaptiveCardsStyleOptions> = {
  adaptiveCardsParserMaxVersion: undefined,
  cardEmphasisBackgroundColor: '#F9F9F9',
  cardPushButtonBackgroundColor: '#0063B1',
  cardPushButtonTextColor: 'White',
  richCardTitleOmitHeadingRole: false,
  richCardWrapTitle: false
};

export default ADAPTIVE_CARDS_DEFAULT_STYLE_OPTIONS;
